import React, { useState } from 'react';

import { useQuery } from '@tanstack/react-query';

import Table from '../../../components/Table';
import ToggleUserEnabledStatus from '../../../components/BrokerSettings/UsersTable/ToggleUserEnabledStatus';
import TablePageLayout from '../../../layouts/TablePageLayout';
import InviteUserModal from '../../../components/Users/InviteUserModal';

import { useUiStore } from '../../../store';
import useUserData from '../../../hooks/useUserData';
import BrokerService from '../../../services/BrokerService';

export default function UsersPage() {
  const [isInviteUserModalVisible, setIsInviteUserModalVisible] =
    useState(false);

  const headerHeight = useUiStore((state) => state.headerHeight);

  const { user } = useUserData();

  const { data: users, refetch } = useQuery({
    queryKey: ['users', user?.brokerId],
    queryFn: () => BrokerService.getBrokerUsers({ id: user?.brokerId }),
    enabled: !!user?.brokerId,
  });

  const cols = [
    {
      title: 'User',
      key: 'name',
      type: 'user',
    },
    {
      title: 'User Role',
      key: 'role',
      type: 'userRole',
    },
    {
      title: 'Email',
      key: 'email',
    },
    {
      title: 'Enabled',
      key: 'isEnabled',
      type: 'component',
      component: ToggleUserEnabledStatus,
      props: (row) => ({ user: row, refetch, disabled: row.id === user.id }),
    },
  ];

  return (
    <div style={{ height: `calc(100dvh - ${headerHeight}px)` }}>
      <TablePageLayout title="Users">
        <Table
          countName="Users"
          cols={cols}
          rows={users}
          createButtonLabel="Invite User"
          onCreateButtonClick={() => setIsInviteUserModalVisible(true)}
        />
      </TablePageLayout>
      <InviteUserModal
        isVisible={isInviteUserModalVisible}
        hideModal={() => setIsInviteUserModalVisible(false)}
        refetch={refetch}
      />
    </div>
  );
}
